/**
 *
 * Asynchronously loads the component for AppointmentNote
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
